import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetBufferedUxpTrackingEventsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBufferedUxpTrackingEventsQuery = { __typename?: 'Query', getBufferedUxpTrackingEvents: Array<{ __typename?: 'UxpTrackingEventPayload', id: string, event: string, options: string, payload: string }> };


export const GetBufferedUxpTrackingEvents = /*#__PURE__*/ gql`
    query GetBufferedUxpTrackingEvents {
  getBufferedUxpTrackingEvents {
    id
    event
    options
    payload
  }
}
    ` as unknown as DocumentNode<GetBufferedUxpTrackingEventsQuery, GetBufferedUxpTrackingEventsQueryVariables>;

          

          export const useGetBufferedUxpTrackingEventsQuery = (options?:QueryHookOptions<GetBufferedUxpTrackingEventsQuery, GetBufferedUxpTrackingEventsQueryVariables>) => useQuery(GetBufferedUxpTrackingEvents, options);

          

          export type GetBufferedUxpTrackingEventsQueryOptions = QueryHookOptions<GetBufferedUxpTrackingEventsQuery, GetBufferedUxpTrackingEventsQueryVariables>;

          

          export const useGetBufferedUxpTrackingEventsLazyQuery = (options?:LazyQueryHookOptions<GetBufferedUxpTrackingEventsQuery, GetBufferedUxpTrackingEventsQueryVariables>) => useLazyQuery(GetBufferedUxpTrackingEvents, options);

          

          export type GetBufferedUxpTrackingEventsQueryResult = ReturnType<typeof useGetBufferedUxpTrackingEventsQuery>;

          
